import { render, staticRenderFns } from "./VotesHistory.vue?vue&type=template&id=7bb9cb2b&scoped=true&"
import script from "./VotesHistory.vue?vue&type=script&lang=js&"
export * from "./VotesHistory.vue?vue&type=script&lang=js&"
import style0 from "./VotesHistory.vue?vue&type=style&index=0&id=7bb9cb2b&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb9cb2b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
